import React, { useState } from 'react';
import { SketchPicker } from 'react-color';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import PaintbrushIcon from '../../../assets/icons/PaintbrushIcon';

import './color-picker.scss';

const ColorSelect = ({ value, onChange, placeholder }) => {
  const [open, setOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className='color-select' onClick={() => setOpen(true)}>
        <div className='flex-centered-row'>
          {value && (
            <div className='color-select__color-box' style={{ '--color-background': value }} />
          )}
          <span className={value ? 'color-text' : 'change-text'}>{value || placeholder}</span>
          { open && (
            <div className='color-select__form'>
              <SketchPicker
                color={value}
                onChange={(color) => onChange(color.hex)}
              />
            </div>
          )}
        </div>

        <div className='flex-centered-row'>
          <PaintbrushIcon color="var(--app-text-subtle)" />
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default ColorSelect;
